/*eslint-disable*/
import { getAchievementsPage } from "../api/AuthenticationServices";
import "../assets/styles/Achievements.css";
import Card from "./card";
import { useState } from "react";
import { useEffect } from "react";
function Achievement() {
  const [records, setRecords] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    try {
      const res = await getAchievementsPage();
      if (res.data.status === "success") {
        setRecords(res.data.data);
        console.log("Records ", records);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }

  return (
    <div className="card-wrapper">
      <h2
        style={{
          textAlign: "center",
          color: "white",
          fontFamily: "'Delicious Handrawn', cursive",
          fontSize: "40px",
        }}
      >
        ACHIEVEMENTS
      </h2>
      {records.length > 0 &&
        records.map((item) => {
          return (
            <div className="card-space">
              <Card
                title={item.title}
                place={item.place}
                date={item.dateOfAch}
                opponent={item.opponent}
                description={item.description}
                scored={item.goalsScored}
                conceded={item.goalsConceded}
                imageUrl={item.photoUrl}
              />
            </div>
          );
        })}
    </div>
  );
}

export default Achievement;
